// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://soueyhxwnjikppvwavfd.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNvdWV5aHh3bmppa3BwdndhdmZkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMyMjYxMzMsImV4cCI6MjA2ODgwMjEzM30.ToC-7KE5RXCKp2vMiUtgQADg9Dx_miJ3oL_Ivy3jZ8g";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});